(function() { module.exports = this["carbon.vendor"]; }());


//////////////////
// WEBPACK FOOTER
// external "carbon.vendor"
// module id = 4
// module chunks = 0